import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideoSolid = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	"aria-hidden": "true",
	focusable: "false",
	"data-prefix": "fas",
	"data-icon": "video",
	className: "svg-inline--fa fa-video",
	role: "img",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 576 512",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M384 112v288c0 26.51-21.49 48-48 48h-288c-26.51 0-48-21.49-48-48v-288c0-26.51 21.49-48 48-48h288C362.5 64 384 85.49 384 112zM576 127.5v256.9c0 25.5-29.17 40.39-50.39 25.79L416 334.7V177.3l109.6-75.56C546.9 87.13 576 102.1 576 127.5z"
	})]
});
const ForwardRef = forwardRef(SvgVideoSolid);
export default ForwardRef;
